import _ from 'lodash';
import { UserIntersectFragment } from 'pages/user/api/fragments/generated/UserIntersect.fragment';

export const sortedUsersFn = (users?: UserIntersectFragment[]) => _.sortBy(_.clone(users), ['lastname']);
